import { render, staticRenderFns } from "./ColorInner.vue?vue&type=template&id=469f657e&"
import script from "./ColorInner.vue?vue&type=script&lang=js&"
export * from "./ColorInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports